import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { DHL_API } from '../../api'
import { useAppStore } from '../../store/useAppStore'
import { QueryKey } from '../../constants'

export interface VehicleDamageData {
  licensePlate: string
  depotCode: string
  timestamp: string
  pNumber: string
  xCoordinate: number
  yCoordinate: number
  description: string
  classifications: string[]
  side: string
  status: string
  voortgang: string
  contactPerson?: string
  pictures: string[]
  claimUploaded: boolean
}

const useDamageMutation = () => {
  const setSnackbar = useAppStore((state) => state.setSnackbar)
  const queryClient = useQueryClient()
  const setDamageRegistrationStep = useAppStore(
    (state) => state.setDamageRegistrationStep
  )

  const { t } = useTranslation()

  const { mutate: sendDamage } = useMutation<VehicleDamageData>(
    ['sendDamage'],
    (body) => DHL_API.post(`api/fleet/storegear/vehicles/damages/new`, body),
    {
      onSuccess: () => {
        setDamageRegistrationStep(0)
        queryClient.invalidateQueries([QueryKey.VehicleData])
      },
      onError: () => {
        const message = t('snackbar.something_went_wrong')
        setSnackbar({
          open: true,
          message,
        })
      },
    }
  )

  return {
    sendDamage,
  }
}

export default useDamageMutation
